<template>
  <div style="width: 100%;">

    <div>
      <patientInfoBox info="ima" class="mtop-04"/>
    </div>
    <!-- NOT IN V1: list of anterior pertinent exams
    <div class="mtop-15">
      <text-item txt="Examens antérieurs pertinents" styles="font-mBold"/>
      <div class="mtop-02">
        <text-item txt="Doppler TSA"/>
        <text-item txt="Angioscan TSA"/>
        <text-item txt="AngioRM TSA"/>
      </div>
    </div> -->

    <template v-for="(region, index) in regionalAnteriorities" :key="index">
      <text-item :txt="region.ui.text"/>
    </template>

    <!-- Separator -->
    <div class="line-h pad-m mtop-20" style="margin-bottom: -2rem;"/>    
  </div>
</template>





<script setup>
import patientInfoBox from '@/views/patientMain/patientInfoBox.vue'

import { computed } from 'vue'
import gen from "@/functions/general.js"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { apiDate } from "@/api/apicommon"
const currentEntryStore = useCurrentEntryStore()
import { getLatestExpr } from '@/functions/expression'


const regionalAnteriorities = computed(() => {
  if (!currentEntryStore.hasCurrentEntry) {return []}

  //regionList
  let regionList = [] //TODO: get matched regions
  regionList = regionList
    .filter(region => region.isMatched == true)
    .map(expr => gen.deepCopy(expr))

  //Read more Data
  const allValidExpr = currentEntryStore.allExpressions
    .filter(expr => expr.isFamilyHistory === false && expr.expressionType === "None" && expr.originalText !== "")
    .map(expr => gen.deepCopy(expr))

  //Create UI-Data for each alertExpr
  for (let region of regionList) {
    //Create lastExpr
    const matchingExprArr = allValidExpr.filter(expr => expr.sctProxyKey === region.sctProxyKey)
    const lastExpr = getLatestExpr(matchingExprArr)
    //Add UI data
    region.ui = {
      "text" : region.originalText,
      "lastExpr" : lastExpr ? gen.deepCopy(lastExpr) : null,
      "lastExprDate": lastExpr ? apiDate(lastExpr.entry.entryStart).getFullYear().toString() : "",
      "lastExprText": lastExpr ? lastExpr.originalText : null,
      "isNormal": lastExpr ? lastExpr.isNormal : null,
    }
  }
  return regionList
})

</script>

<style scoped>
</style>